import Breadcrumbs from './breadcrumbs'
import BtnDownload from './btn-download'
import ButtonsGroup from './buttons-group'
import Certifications from './certifications'
import Contact from './contact'
import DefaultGrid from './default-grid'
import Download from './download'
import FormSection from './form-section'
import GridCard from './grid-card'
import GridPostTypes from './grid-post-types'
import HeroCategory from './hero-category'
import HeroCover from './hero-cover'
import IconsBlocks from './icons-blocks'
import ImageFull from './image-full'
import ImageText from './image-text'
import ImageTextSquared from './image-text-squared'
import Infographic from './infographic'
import InfographicCarousel from './infographic-carousel'
import InlineText from './inline-text'
import IntroText from './intro-text'
import MediaBlock from './media-block'
import ProductDetailHero from './product-detail-hero'
import ProductIconList from './product-icon-list'
import ProductsGrid from './products-grid'
import ProductsPush from './products-push'
import Spacer from './spacer'
import TextBlock from './text-block'
import VideoBlock from './video-block'

export const sectionsMap: any = {
  breadcrumbs: Breadcrumbs,
  btn_download: BtnDownload,
  buttons_group: ButtonsGroup,
  certifications: Certifications,
  contact: Contact,
  default_grid: DefaultGrid,
  download: Download,
  form: FormSection,
  grid_post_types: GridPostTypes,
  hero_category: HeroCategory,
  hero_cover: HeroCover,
  icons_blocks: IconsBlocks,
  image_full: ImageFull,
  image_text: ImageText,
  image_text_squared: ImageTextSquared,
  infographic: Infographic,
  infographic_carousel: InfographicCarousel,
  text_inline: InlineText,
  intro_text: IntroText,
  media_block: MediaBlock,
  product_detail_hero: ProductDetailHero,
  product_icon_list: ProductIconList,
  products_grid: ProductsGrid,
  products_push: ProductsPush,
  spacer: Spacer,
  text_block: TextBlock,
  video_block: VideoBlock,
  grid_card: GridCard
}
